import { PagedRequestType, PagedResultsType } from "../../../types/PagedResults";
import { get } from "../../../utils/axios-config";
import { SCIENTIFICAREAS } from "../../../utils/constants";
import { ScientificAreaType } from "../../../types/ScientificAreas";

export const getScientificAreas = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
        ...(data?.IdFaculty ? { IdFaculty: data.IdFaculty } : {}),
    });
    const url = `${SCIENTIFICAREAS}?${queryParams.toString()}`;
    return await get<PagedResultsType<ScientificAreaType>>(url)
};